import {Layers, RockBottomLayers, SimpleStageLayer} from "./RockBottomLayers";
import {RockBottom} from "../RockBottom";
import {gsap} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RockBottomSound} from "../sound/RockBottomSound";

export class RockBottomCharacterIntro extends PIXI.Container {
    private _layer: SimpleStageLayer | undefined;
    private _character: PIXI.Sprite;
    private _stopTl: gsap.core.Timeline | null;
    private _overlay: PIXI.Graphics;

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    public playCharacterIntro(): void {
        this.visible = true;
        this._character.visible = true;
        this._overlay.visible = true;

        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onStart: () => {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.CHARACTER_INTRO});
                },
                onComplete: () => {
                    this.stopCharacterIntro();
                }
            }),
            fps: number = 30;

        tl.to(this.position, {
            x: 320,
            y: 360,
            duration: 5 / fps
        }, 0);
        tl.to(this.position, {
            x: 384,
            y: 370,
            duration: (70 / fps)
        }, 5 / fps);
        tl.to(this.position, {
            x: 2000,
            y: -602,
            duration: 5 / fps,
            onStart: () => {
                gsap.to(this._overlay, {alpha: 0, duration: 5 / fps});
            },
            onComplete: () => {
                this._overlay.visible = false;
            }
        }, (75 / fps));
    }

    public stopCharacterIntro(skipped: boolean = false): void {
        // if already stopped
        if (this._stopTl || this.children.length === 0) {
            return;
        }

        this._stopTl = gsap.timeline({
            onComplete: () => {
                this.cleanCharacterIntro();
            }
        });
        this._stopTl.to(this, {
            duration: 0.2,
            alpha: 0
        });
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.SPLASH_INTRO);
        this.createOverlay();
        this.visible = false;
        this.position.set(-1154, 360);

        this._character = new PIXI.Sprite(RockBottom.assetLoader.getTextures("introSplash")[0]);
        this._character.visible = false;
        this._character.anchor.set(0.5);
        this.addChild(this._character);
        this._layer?.addChild(this);
    }

    private cleanCharacterIntro(): void {
        this._stopTl = null;
        this.visible = false;
        this._overlay.visible = false;
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this.setOverlayProps();
        this._layer?.addChild(this._overlay);
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private setOverlayProps(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 0.75);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
    }
}